import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'config';
import _find from 'lodash/find';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import * as appActions from 'store/modules/app';
import './LangSwitcher.scss';

function LangSwitcher(props) {
  const langItems = [
    { name: '한국어', value: 'ko' },
    { name: 'English', value: 'en' },
    { name: '中文', value: 'zh' }
  ];
  const dispatch = useDispatch();
  const setLanguage = lang => dispatch(appActions.setLanguage(lang));
  const language = useSelector(state => state.app.language);
  const selectRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { onChange } = props;
  const handleItemClick = v => {
    setLanguage(v);
    setIsOpen(false);
    selectRef.current.blur();
  };
  return (
    <div
      ref={selectRef}
      className="lang-switcher"
      tabindex="-1"
      onBlur={e => setIsOpen(false)}
    >
      <div className="select-indicator" onClick={e => {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}>

        {_find(langItems, { value: language }) ? (
          <span>
            <img
              src={`${config.STATIC_BASE_URL}/images/icon/flag/${
                _find(langItems, { value: language }).value
              }_rounded.png`}
              alt={'flag'}
            />
            {_find(langItems, { value: language }).name}
          </span>
        ) : (
          '선택...'
        )}
        <div className="select-icon">
          {isOpen ? <FaCaretUp /> : <FaCaretDown />}
        </div>
      </div>
      <div class={`select-items-container ${isOpen ? 'open' : ''}`}>
        <ul class="select-items-list">
          {langItems.map(n => (
            <li
              class={`select-item ${language === n.value ? 'active' : ''}`}
              onClick={() => handleItemClick(n.value)}
            >
              <img
                src={`${config.STATIC_BASE_URL}/images/icon/flag/${n.value}_rounded.png`}
                alt={n.value}
              />
              {n.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default LangSwitcher;
